import LegalLayout, { LegalSection, LegalList } from "./LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout
      title="개인정보처리방침"
      subtitle="주식회사 툴뮤직은 이용자의 개인정보를 소중히 여기며, 관련 법령을 준수합니다."
      updatedAt="2026년 3월 27일"
    >
      <LegalSection title="제1조 (개인정보의 수집 및 이용 목적)">
        <p>주식회사 툴뮤직(이하 "회사")은 K-ArtPEN 서비스 제공을 위해 아래와 같이 개인정보를 수집·이용합니다.</p>
        <LegalList items={[
          "회원 가입 및 서비스 이용 관리",
          "교육 시뮬레이션 콘텐츠 제공 및 맞춤 서비스",
          "강사 및 학생 계정 관리, 워크스페이스 운영",
          "도입 문의 및 고객 응대",
          "서비스 품질 개선 및 통계 분석",
        ]} />
      </LegalSection>

      <LegalSection title="제2조 (수집하는 개인정보의 항목)">
        <p><strong className="text-[#CCCCCC]">필수 수집 항목</strong></p>
        <LegalList items={[
          "이메일 주소, 비밀번호 (회원가입 시)",
          "표시명(닉네임), 역할(학생/강사)",
          "서비스 이용 기록, 접속 로그, 쿠키",
        ]} />
        <p className="mt-3"><strong className="text-[#CCCCCC]">선택 수집 항목</strong></p>
        <LegalList items={[
          "소속 기관, 연락처 (도입 문의 시)",
          "학습 성과 데이터, 시뮬레이션 결과",
        ]} />
      </LegalSection>

      <LegalSection title="제3조 (개인정보의 보유 및 이용 기간)">
        <p>회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계 법령에 의해 보존이 필요한 경우 해당 기간 동안 보존합니다.</p>
        <LegalList items={[
          "회원 정보: 회원 탈퇴 시까지 (탈퇴 후 30일 내 파기)",
          "전자상거래 관련 기록: 5년 (전자상거래법)",
          "접속 로그: 3개월 (통신비밀보호법)",
          "도입 문의 기록: 문의 처리 완료 후 1년",
        ]} />
      </LegalSection>

      <LegalSection title="제4조 (개인정보의 제3자 제공)">
        <p>회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 단, 다음의 경우는 예외로 합니다.</p>
        <LegalList items={[
          "이용자가 사전에 동의한 경우",
          "법령의 규정에 의하거나 수사 목적으로 법령에 정해진 절차에 따라 요청이 있는 경우",
          "서비스 제공에 필수적인 위탁업체에 제공하는 경우 (Supabase 클라우드 서비스 등)",
        ]} />
      </LegalSection>

      <LegalSection title="제5조 (개인정보의 파기 절차 및 방법)">
        <p>회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때 지체 없이 파기합니다.</p>
        <LegalList items={[
          "전자적 파일 형태: 재생 불가능한 기술적 방법으로 삭제",
          "종이에 출력된 개인정보: 분쇄기로 분쇄 또는 소각",
        ]} />
      </LegalSection>

      <LegalSection title="제6조 (이용자의 권리)">
        <p>이용자는 언제든지 다음의 권리를 행사할 수 있습니다.</p>
        <LegalList items={[
          "개인정보 열람 요청",
          "개인정보 정정·삭제 요청",
          "개인정보 처리 정지 요청",
          "개인정보 이동 요청",
        ]} />
        <p className="mt-3">권리 행사는 <span className="text-[#7A9BFF]">eunhyun1@naver.com</span>으로 서면, 이메일로 요청할 수 있으며, 회사는 지체 없이 조치하겠습니다.</p>
      </LegalSection>

      <LegalSection title="제7조 (개인정보 보호책임자)">
        <LegalList items={[
          "성명: 개인정보 보호책임자",
          "소속: 주식회사 툴뮤직",
          "이메일: eunhyun1@naver.com",
          "전화: 서비스 내 고객센터 문의",
        ]} />
      </LegalSection>

      <LegalSection title="제8조 (개인정보처리방침의 변경)">
        <p>본 방침은 2026년 3월 27일부터 시행됩니다. 내용의 변경이 있을 경우 시행 7일 전부터 서비스 내 공지사항을 통해 고지합니다.</p>
      </LegalSection>
    </LegalLayout>
  );
}
